import { render, staticRenderFns } from "./OrderReportDetail.vue?vue&type=template&id=73bf93aa&scoped=true"
import script from "./OrderReportDetail.vue?vue&type=script&lang=js"
export * from "./OrderReportDetail.vue?vue&type=script&lang=js"
import style0 from "./OrderReportDetail.vue?vue&type=style&index=0&id=73bf93aa&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73bf93aa",
  null
  
)

export default component.exports